import { useMemo } from "react";
import { Option, OptionText, ImgContainer } from "./Questions.style";
import { htmlDecode, removeEqualQuotes } from "../../utils/parse";


function Options(props) {
  const { mark, option, radio, isQuestionImg } = props;

  const imageURL = useMemo(() => {
     if(!props.images) return null;
     return props.images.startsWith('https://drive.g') ? null : props.images;
  }, [props.images]);

  return (
    <div className="optioncontainer">
      <Option isQuestionImg={isQuestionImg}>
        <div
          style={{
            border: "1px solid #5ce0d2",
            borderRadius: "10px",
            padding: "9px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {radio && (
              <div
                style={
                  mark
                    ? { backgroundColor: "#5ce0d2" }
                    : { backgroundColor: "#fff" }
                }
                className="mark"
              ></div>
            )}
            <OptionText>
              <div
                style={{textTransform:props.isTF?"capitalize":""}}
                dangerouslySetInnerHTML={{ __html: htmlDecode(removeEqualQuotes(option?.value || "")) }}
              ></div>
            </OptionText>
          </div>
          {imageURL && (
            <ImgContainer>
              <img src={imageURL} alt="optionsImage" />
            </ImgContainer>
          )}
        </div>
      </Option>
    </div>
  );
}

Options.defaultProps = {
  radio: true,
};
export default Options;
